import Vue from 'vue'
import { Mixin } from 'vue-mixin-decorator'

@Mixin
export default class UpdateMixin extends Vue {
    refreshing = false
    registration: any = null
    updateExists = false

    created() {
        // console.log('Service worker: UpdateMixin created, navigator.serviceWorker ', navigator.serviceWorker)
        // Listen for our custom event from the SW registration
        document.addEventListener('swUpdated', this.updateAvailable, { once: true })

        // Prevent multiple refreshes
        navigator.serviceWorker.addEventListener('controllerchange', () => {
            // console.log('Service worker: Prevent multiple refreshes')
            if (this.refreshing) return
            this.refreshing = true
            // Here the actual reload of the page occurs
            console.log('Service-worker: controllerchange')

            // window.location.reload()
        })
    }

    updateAvailable(event: any) {
        this.registration = event.detail
        this.updateExists = true
    }

    async refreshApp() {
        // console.log('Service worker: refreshApp')
        // CLEAR VUEX
        this.$store.commit('resetAuthentication')
        this.$store.commit('resetAttachment')
        this.$store.commit('resetAuthorization')
        this.$store.commit('resetComment')
        this.$store.commit('resetCompany')
        this.$store.commit('resetObservation')
        this.$store.commit('resetProject')
        this.$store.commit('resetTask')
        this.$store.commit('resetUser')
        this.$store.commit('resetObservationHelpers')
        this.$store.commit('resetSystemLanguage')
        this.$store.commit('resetSnackbar')
        this.$store.commit('resetDialog')
        this.$store.commit('resetDrawer')
        this.$store.commit('resetProjectHelpers')

        // document.location.reload()
        // Make sure we only send a 'skip waiting' message if the SW is waiting
        if (!this.registration || !this.registration.waiting) return
        // send message to SW to skip the waiting and activate the new SW
        this.registration.waiting.postMessage({ type: 'SKIP_WAITING' })
        this.updateExists = false
    }
}
